import React, { useEffect, useRef } from 'react'
// eslint-disable-next-line import/named
import { FieldHookConfig } from 'formik'

type UsePropagateRefProps = {
  setFieldValue: React.Dispatch<
    React.SetStateAction<string | number | null | undefined>
  >
  name: string | FieldHookConfig<never>
  value: string | number | null | undefined
}
export function usePropagateRef(props: UsePropagateRefProps) {
  const { name, value, setFieldValue } = props

  const flagRef = useRef(true)
  useEffect(() => {
    if (flagRef.current) {
      flagRef.current = false
      return
    }
    setFieldValue(value)
    // eslint-disable-next-line
  }, [name]);
}
